
const headers = [{
  value: 'product', title: 'Product', sortable: false, centered: false,
}, {
  value: 'price', title: 'Price', sortable: false, centered: false,
}, {
  value: 'rate', title: 'Rate', sortable: false, centered: false,
}, {
  value: 'actions', title: 'Actions', sortable: false, centered: false,
}]

const statuses = [{
  label: 'Paid',
  value: 'paid',
}, {
  label: 'Pending',
  value: 'pending',
}, {
  label: 'Failed',
  value: 'failed',
}, {
  label: 'Partially refunded',
  value: 'partially_refunded',
}]

const colgroup = ['50%', '10%', '15%', '25%']

const defaultFilters = {
  query: '',
  status: [],
  fileType: [],
}

const defaultTable = {
  className: 'products-list',
  select: false,
  rows: [],
  colgroup,
  headers,
}

export {
  statuses,
  defaultFilters,
  defaultTable,
}
